"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildCustomSelectPickerFilter = exports.buildUserFilter = exports.buildDateFilter = exports.buildIdFilter = void 0;

/**
 * Builds a an odata id filter
 * @param ids
 * @param filterKey Property to filter on
 * @param idAsGuid True if the serverside representation of the value is a guid
 * Example: $filter=id in (2df1e0d3-303e-4512-accd-41ff2ed52e96)
 */
var buildIdFilter = function buildIdFilter(ids, filterKey, idAsGuid) {
  var filter = {};

  if (!ids || ids.length < 1) {
    return filter;
  }

  filter[filterKey] = idAsGuid ? {
    in: {
      type: "guid",
      value: ids
    }
  } : {
    in: ids
  };
  return filter;
};
/**
 * Return an odata filter for a date/time range.
 * @param dateFilter Date/time range (0 is startDate, 1 is endDate).
 * @param filterKey Property to filter on
 * @param isCollection True if the filter is for a collection of date/time range values.
 * @param collectionKey  The property name of what is inside the 'any' odata filter.
 * Example: $filter=filterKey ge '2018-05-30T00:00:00Z' and le '2019-10-31T:00:00:00Z'
 * Collection Example: $filter=filterKey/any(x: x/collectionKey ge '2018-05-30T00:00:00Z' and le '2019-10-31T:00:00:00Z')
 */


exports.buildIdFilter = buildIdFilter;

var buildDateFilter = function buildDateFilter(dateFilter, filterKey) {
  var isCollection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var collectionKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  var filter = {};

  if (!dateFilter || dateFilter.length < 1) {
    return filter;
  }

  var innerFilter = {};

  if (dateFilter[0] && dateFilter[1]) {
    innerFilter = {
      ge: dateFilter[0],
      le: dateFilter[1]
    };
  } else if (dateFilter[0]) {
    innerFilter = {
      ge: dateFilter[0]
    };
  } else if (dateFilter[1]) {
    innerFilter = {
      le: dateFilter[1]
    };
  }

  if (isCollection && collectionKey) {
    filter[filterKey] = {};
    filter[filterKey]["any"] = {};
    filter[filterKey]["any"][collectionKey] = innerFilter;
  } else {
    filter[filterKey] = innerFilter;
  }

  return filter;
};
/**
 * Builds a an odata user filter
 * @param userFilter List of users to filter on
 * @param filterKey Property to filter on
 * @param idAsGuid True if the serverside representation of the value is a guid
 * Example: $filter=lastModified in ('1', '2', '3')
 */


exports.buildDateFilter = buildDateFilter;

var buildUserFilter = function buildUserFilter(userFilter, filterKey, idAsGuid) {
  var ids = userFilter ? userFilter.map(function (user) {
    return user.value;
  }) : [];
  return buildIdFilter(ids, filterKey, idAsGuid);
};
/**
 *
 * @param selectFilter Values of the select filter
 * @param filterKey Property to filter on
 * @param isCollection True if the filter is for a collection of date/time range values.
 * @param collectionKey  The property name of what is inside the 'any' odata filter.
 * Example: $filter=filterKey in ('test', 'filter', 'value')
 * Collection Example: $filter=filterKey/any(x: x/collectionKey in ('test', 'filter', 'value'))
 */


exports.buildUserFilter = buildUserFilter;

var buildCustomSelectPickerFilter = function buildCustomSelectPickerFilter(selectFilter, filterKey) {
  var isCollection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var collectionKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  var filter = {};

  if (!selectFilter || selectFilter.length < 1) {
    return filter;
  }

  var values = [];
  selectFilter.forEach(function (val) {
    return Array.isArray(val.value) ? val.value.forEach(function (v) {
      return values.push(v);
    }) : values.push(val.value);
  });
  var innerFilter = {
    in: values
  };

  if (isCollection && collectionKey) {
    filter[filterKey] = {};
    filter[filterKey]["any"] = {};
    filter[filterKey]["any"][collectionKey] = innerFilter;
  } else {
    filter[filterKey] = innerFilter;
  }

  return filter;
};

exports.buildCustomSelectPickerFilter = buildCustomSelectPickerFilter;